import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { getGradeLabel } from '@Utils/gradeLabels';
import { GRADE_CONFIG } from '../gradeConfig';

interface GradeBadgeCellProps {
	grade: string | number | null | undefined;
}

// getGradeLabel switches on the legacy grade keys, not the display names.
const LEGACY_KEY: Record<string, string> = {
	'0': 'negligible',
	'1': 'low',
	'2': 'medium',
	'3': 'high',
	'4': 'extreme',
};

// Redesigned grade pill (flag on). Colours come from the shared GRADE_CONFIG;
// GRADE_CONFIG.label is an English display name, so the translated label comes
// from the shared getGradeLabel using the legacy key for the grade value.
export const GradeBadgeCell = ({ grade }: GradeBadgeCellProps) => {
	const { t } = useGlobalization();
	const key = grade === null || grade === undefined ? '' : String(grade);
	const cfg = Object.hasOwn(GRADE_CONFIG, key)
		? GRADE_CONFIG[key]
		: undefined;
	if (!cfg) return <></>;
	return (
		<span
			data-cy={`risk-grade-badge-${key}`}
			style={{
				color: cfg.chipColor,
				backgroundColor: cfg.bg,
				borderRadius: 12,
				padding: '1px 10px',
				border: `1px solid ${cfg.chipColor}33`,
				textTransform: 'uppercase',
				fontSize: 12,
				fontWeight: 600,
				lineHeight: '18px',
				display: 'inline-block',
			}}>
			{getGradeLabel(LEGACY_KEY[key], t)}
		</span>
	);
};
